import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import qp from 'query-parse';
import BaseRequestsPaginationPage from '../../../../components/admin/containers/BaseRequestsPaginationPage';
import GeneralTableRow from '../../../../components/admin/table/row';
import * as requestsManagerActionCreators from '../../../../redux/modules/requests-manager';
import InfoTooltip from '../../../../components/common/tooltip/info/index';
import Loading from '../../../../components/common/loading/index';
import AllActionButtons from '../../../../components/actions/all';
import { withNamespaces } from 'react-i18next';
import i18n from "i18next";
import * as authActions from "../../../../redux/modules/auth";
import {push} from "react-router-redux";
import cookieAndLocalStorage from "../../../../helpers/cookieAndLocalStorage";

class RequestsPage extends React.Component {
  constructor(props) {
    super(props);

    this.changeFilter = this.changeFilter.bind(this);
    this.actionButtonEvents = {
      approveRequest: (harcirahId) => {
        const { approveRequest } = this.props;
        approveRequest(harcirahId);
      },
      rejectedRequest: async (state) => {
        const { harcirahId, description } = state;
        const { rejectedRequest } = this.props;

        await rejectedRequest({ harcirahId, description, });
        setTimeout(() => { this.callFilterAfterReject(); }, 3500);
      },
      renderPage: async () => {
        await this.callFilterAfterReject();
      }
    };

    this.state = {
      requestStatus: 'all'
    };
  }

  async callFilterAfterReject() {
    const currentQuery = qp.toObject(this.props.location.search.substring(1));

    const filter = {
      month: currentQuery.month ? currentQuery.month : 0,
      year: currentQuery.year ? currentQuery.year : 0,
      requestStatus: currentQuery.requestStatus
        ? currentQuery.requestStatus
        : 'all',
      page: this.props.match.params.page,
    };

    await this.changeFilter(filter);
  }

  async changeFilter(filter) {
    const {
      month, year, page, requestStatus,
    } = filter;
    const { fetchRequests } = this.props;

    this.setState({ requestStatus });
    await fetchRequests({
      month, year, activePage: page, requestStatus, rowCount: 10,
    });
  }
  async componentDidMount() {
    const { language,isCheckToken,isActive } = this.props;
    this.setState({updateLanguage:true})
    i18n.changeLanguage(language)

    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }
  async componentWillMount(){
    const { isCheckToken,isActive } = this.props;
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }

  render() {
      const { requestStore, selectRequest, match, t, i18n, language } = this.props;
    return (
      <BaseRequestsPaginationPage
        filterOptionValue="admin"
        pageCount={this.props.pageCount}
        changeFilter={this.changeFilter}
      >
        <div className="col-md-12">
          <div className="card">
            <div className="content table-responsive table-full-width">
              <Loading loading={requestStore.loading} rows={5} colSpan={9}>
                <div className="requests">
                  <div className="requests-column">
                    <div className="row">
                      <div className="col-md-first" />
                      <div className="col-md-1">
                        <h5>
                       {t('selection')}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                        {t('nameSurname')}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                        {t('travelDate')}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                        {t('reasonForTravel')}
                        </h5>
                      </div>
                      <div className="col-md-1">
                        <h5>
                        {t('cityCounty')}
                        </h5>
                      </div>
                      <div className="col-md-1">
                        <InfoTooltip info= {t('travelExpensesGross')}>
                          <h5>
                          {t('travelExpensesGross')}
                          </h5>
                        </InfoTooltip>
                      </div>
                      <div className="col-md-1">
                        <InfoTooltip info={t('individualAccommodationNet')}>
                          <h5>
                          {t('individualAccommodationNet')}
                          </h5>
                        </InfoTooltip>
                      </div>
                      <div className="col-md-last">
                        <h5>
                        {t('transaction')}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="requests-content">
                    {requestStore.requests.map(request => (
                      <GeneralTableRow
                        actionButtonEvents={this.actionButtonEvents}
                        key={request.group_id}
                        select={selectRequest}
                        request={request.harcirah[0]}
                        group_id={request.group_id}
                        subRequest={request.harcirah}
                      />
                    ))}
                  </div>
                </div>
              </Loading>
            </div>
          </div>
          <Loading loading={requestStore.loading} rows={1} colSpan={2}>
          <AllActionButtons
            actionButtonEvents={this.actionButtonEvents}
            requestStore={requestStore}
            selectRequest={selectRequest}
            pageCount={match.params.page}
            requestStatus={this.state.requestStatus}
          />
          </Loading>
        </div>
      </BaseRequestsPaginationPage>
    );
  }
}

const mapStateToProps = state => ({
  pageCount: state.requestsForManager.pageCount,
  requestStore: state.requestsForManager,
  language: state.auth.language,
  isActive: state.auth.isActive,
});

const mapDispatchToProps = dispatch => bindActionCreators(
    {
      ...requestsManagerActionCreators,
      ...authActions
    },
    dispatch
);



export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(RequestsPage));



// WEBPACK FOOTER //
// ./src/pages/travel-expense/detail/admin/index.js